import React, { Component } from 'react';
import PropTypes from "prop-types";
import axios from "axios";
import { API_URL, ERROR_HANDLE } from "config/constants";
import theme from '../../../../Theme/theme';
import Spinner from '../../../../components/LoadingSpinner';
import Button from "../../../../components/UI/Button";
import SearchBox from "../../../../components/SearchBox";
import "./style.css";
import { Constants } from '../../../../common/constants';

const SELECT_ALL_TEXT = "Select All"
const UNSELECT_ALL_TEXT = "Unselect All"
const SEARCH_TEXT = "Search by package name"
const NO_PACKAGE_FOUND = "No packages found"
const SELECTION_ICON = require('../../../../assets/images/selection_icon.png');

/**
 * An component used to select the packages from the list
 */
class PackagesList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            packagesList: [],
            filteredPackages: [],
            isLoading: true,
            packagesSelected: []
        }
    }

    componentDidMount() {
        (this.props.packagesList && this.props.packagesList.length > 0) ?
            this.setState({ packagesList: this.props.packagesList, filteredPackages: this.props.packagesList, isLoading: false }, () => this.setState({
                packagesSelected: this.props.packagesSelected
            })) : this.getPackagesList();
    }

    getPackagesList() {
        const access_token = localStorage.getItem("access_token");
        axios.get(`${API_URL}/promos/packages`, {
            headers: {
                "x-access-token": access_token
            }
        }).then(res => {
            if (!res.error) {
                this.setState({
                    packagesList: res.data,
                    filteredPackages: res.data,
                    isLoading: false
                }, () => {
                    let packagesSelected;
                    if (this.props.packagesSelected.includes(-1)) {
                        packagesSelected = res.data.map(item => item.id);
                    } else
                        packagesSelected = this.props.packagesSelected;
                    this.setState({
                        packagesSelected
                    });
                    this.props.updatePackagesList(this.state.packagesList)
                })
            } else {
                if (res.error === Constants.ERR0R_INVALID_AUTH_TOKEN) {
                    window.location.assign("/");
                }
                this.setState({ isLoading: false });
            }
        }).catch(err => {
            ERROR_HANDLE(err);
            this.setState({ isLoading: false });
        });
    }

    updateSelectedPackage(pack) {
        const index = this.state.packagesSelected.indexOf(pack.id);
        let packagesSelected = [...this.state.packagesSelected];
        if (index !== -1) {
            packagesSelected.splice(index, 1);
        } else {
            packagesSelected.push(pack.id);
        }
        this.updateSelected(packagesSelected);
    }

    updateSelected(packagesSelected) {
        this.setState({
            packagesSelected
        }, () => this.props.updateSelectedPackages(packagesSelected.length == this.state.packagesList.length ? [-1] : packagesSelected));
    }

    selectAllPackages() {
        let packagesSelected = this.state.packagesList.map(item => item.id);
        this.updateSelected(packagesSelected);
    }

    unSelectAllPackages() {
        this.updateSelected([]);
    }

    renderPackageList() {
        return (
            this.state.filteredPackages.length > 0 ? <div style={style.container}>
                {this.state.filteredPackages.map((pack, index) => {
                    const packageIndex = this.state.packagesSelected.indexOf(pack.id);
                    return (
                        pack.promocode && <div key={"packageList" + index} style={style.packageNameContainer} onClick={() => this.updateSelectedPackage(pack)}>
                            <div style={style.packageName}>{pack.promocode}</div>
                            {(packageIndex >= 0) && <img style={{ width: 25, height: 25, marginTop: -4 }} src={SELECTION_ICON} />}
                        </div>
                    )
                })}
            </div> : <div style={{ ...style.container, ...style.alertContainer }}> {NO_PACKAGE_FOUND}</div>
        )
    }

    renderSearchPackagesButton = () => {
        return (
            <div style={style.searchPackageContainer}>
                <SearchBox
                    hideSearchImage={true}
                    placeholder={SEARCH_TEXT}
                    searchWrapperStyle={style.searchWrapper}
                    searchInputStyle={style.searchInput}
                    onChange={(e) => this.searchHandler(e)}>
                </SearchBox>
                {<div style={style.selectPackageCount}>{this.state.packagesSelected.length}</div>}
            </div>
        );
    }

    renderSelectPackagesButton = () => {
        return (
            < div style={style.selectPackageButtonContainer} >
                <Button
                    style={this.state.packagesList.length === this.state.packagesSelected.length ? { ...style.selectButton, ...{ background: theme.color.mediumPrimaryBlue } } : style.selectButton}
                    type="primary"
                    onClick={() => this.selectAllPackages()}
                >
                    {SELECT_ALL_TEXT}
                </Button>
                <Button
                    style={this.state.packagesSelected.length === 0 ? { ...style.selectButton, ...{ background: theme.color.mediumPrimaryBlue } } : style.selectButton}
                    type="primary"
                    onClick={() => this.unSelectAllPackages()}
                >
                    {UNSELECT_ALL_TEXT}
                </Button>
            </div >
        )
    }

    searchHandler = (e) => {
        const filteredPackages = this.state.packagesList.filter(pack => {
            const packageName = pack.promocode;
            return packageName && packageName.toLowerCase().includes(e.target.value.toLowerCase()) > 0
        })
        this.setState({ filteredPackages })
    }

    render() {
        return (
            this.state.isLoading ? <Spinner loading={this.state.isLoading} /> :
                <div>
                    {this.renderSelectPackagesButton()}
                    {this.renderSearchPackagesButton()}
                    {this.renderPackageList()}
                </div>
        )
    }
}

PackagesList.propTypes = {
    packagesList: PropTypes.array.isRequired,
    packagesSelected: PropTypes.array.isRequired,
    updatePackagesList: PropTypes.func.isRequired,
    updateSelectedPackages: PropTypes.func.isRequired,
};

const style = {
    container: {
        display: 'flex',
        width: 400,
        height: 350,
        overflowY: "auto",
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: theme.color.white,
        boxShadow: "1px 2px 4px " + theme.color.shadowColor,
        borderRadius: "0px 0px 10px 10px",
        marginBottom: 8
    },
    packageNameContainer: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        height: 60,
        width: "100%",
        borderBottom: "2px solid " + theme.color.tableSeparatorGrey
    },
    packageName: {
        width: "86%",
        verticalAlign: "middle",
        textAlign: "left",
        lineHeight: "60px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingLeft: 10,
        fontSize: 17,
        letterSpacing: 0,
        fontFamily: theme.font.avenirMedium,
        color: theme.color.thickGrey
    },
    alertContainer: {
        height: 150,
        justifyContent: "center",
        fontSize: 26,
        fontFamily: theme.font.glacialIndifference,
        fontWeight: theme.fontWeight.bold,
        fontStyle: theme.fontWeight.regular,
        color: theme.color.thickGrey,
        textAlign: 'center',
        background: theme.color.white
    },
    selectPackageButtonContainer: {
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        alignItems: "center"
    },
    selectButton: {
        width: 150,
        fontSize: 17,
        marginBottom: 10,
        borderRadius: 8,
        height: 40,
        color: theme.color.thickGrey,
        backgroundColor: theme.color.white,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: theme.color.primaryBlue
    },
    searchPackageContainer: {
        display: "flex",
        width: "100%",
        justifyContent: "flex-start",
        alignItems: "center",
        borderRadius: "10px 10px 0px 0px",
        boxShadow: "1px 2px 4px " + theme.color.shadowColor,
        lineHeight: "60px",
        backgroundColor: theme.color.black
    },
    selectPackageCount: {
        textAlign: "center",
        fontSize: 20,
        lineHeight: "50px",
        height: "50px",
        width: "50px",
        borderRadius: "25px",
        backgroundColor: theme.color.white,
        fontFamily: theme.font.avenirBlackOblique,
        color: theme.color.black
    },
    selectPackageButton: {
        textAlign: "center",
        fontSize: 28,
        fontFamily: theme.font.avenirHeavyOblique,
        color: theme.color.white
    },
    searchWrapper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "10px",
        width: "80%",
        position: "relative"
    },
    searchInput: {
        backgroundColor: theme.color.lightGrey,
        borderRadius: 32,
        borderWidth: 2,
        borderStyle: "solid",
        borderColor: theme.color.white,
        fontSize: 20,
        fontFamily: theme.font.avenirHeavyOblique,
        color: theme.color.searchTextGrey,
        width: "100%",
        paddingLeft: 20,
        textAlign: "left"
    }
};

export default PackagesList;

